// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetClinicAndHomeProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/reports/clinic_&_home", false, /\.(png|jpe?g|svg)$/)
  );

  const fullBodyProtocolsImg = importImages(
    require.context("../../../../assets/images/protocols/reports/web/fullBody", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.clinicAndHome.SPHEROIDS.id]: {
      img: protocolImg["./spheroids.png"],
      imgResponsive: protocolImg["./spheroids_responsive.png"],
      name: "uppercaseProtocols_spheroids",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.PINBALL.id]: {
      img: protocolImg["./pinball.png"],
      imgResponsive: protocolImg["./pinball_responsive.png"],
      name: "uppercaseProtocols_pinball",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.HOCKEY.id]: {
      img: protocolImg["./hockey.png"],
      imgResponsive: protocolImg["./hockey_responsive.png"],
      name: "uppercaseProtocols_hockey",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.CLEAN_THE_TABLE.id]: {
      img: protocolImg["./clean_the_table.png"],
      imgResponsive: protocolImg["./clean_the_table_responsive.png"],
      name: "uppercaseProtocols_cleanTheTable",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.GRASP_AND_PLACE.id]: {
      img: protocolImg["./grasp_and_place.png"],
      imgResponsive: protocolImg["./grasp_and_place_responsive.png"],
      name: "uppercaseProtocols_graspAndPlace",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.FOLLOW_THE_LINE.id]: {
      img: protocolImg["./follow_the_line.png"],
      imgResponsive: protocolImg["./follow_the_line_responsive.png"],
      name: "uppercaseProtocols_followTheLine",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.ROAD_TRIP.id]: {
      img: protocolImg["./roadtrip.png"],
      imgResponsive: protocolImg["./roadtrip_responsive.png"],
      name: "uppercaseProtocols_roadTrip",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.BRICKS.id]: {
      img: protocolImg["./bricks.png"],
      imgResponsive: protocolImg["./bricks_responsive.png"],
      name: "uppercaseProtocols_bricks",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.BOAT.id]: {
      img: protocolImg["./boat.png"],
      imgResponsive: protocolImg["./boat_responsive.png"],
      name: "uppercaseProtocols_boat",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.BUBBLES.id]: {
      img: protocolImg["./bubbles.png"],
      imgResponsive: protocolImg["./bubbles_responsive.png"],
      name: "uppercaseProtocols_bubbles",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.DEMOLITION.id]: {
      img: protocolImg["./demolition.png"],
      imgResponsive: protocolImg["./demolition_responsive.png"],
      name: "uppercaseProtocols_demolition",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.CATERING.id]: {
      img: protocolImg["./catering.png"],
      imgResponsive: protocolImg["./catering_responsive.png"],
      name: "uppercaseProtocols_catering",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.CONSTELLATIONS.id]: {
      img: protocolImg["./constellations.png"],
      imgResponsive: protocolImg["./constellations_responsive.png"],
      name: "uppercaseProtocols_constellations",
      description: "reports_promotedExercisesText",
    },
    [protocols.clinicAndHome.TWISTER_BUDDY.id]: {
      img: fullBodyProtocolsImg["./twister_buddy.png"],
      imgResponsive: fullBodyProtocolsImg["./twister_buddy_responsive.png"],
      name: "uppercaseProtocols_twisterBuddy",
      description: "protocols_twisterBuddyDescription",
      video: "protocols_twisterBuddyVideo",
    },
    [protocols.clinicAndHome.COSTUME_PARTY.id]: {
      img: fullBodyProtocolsImg["./costume_party.png"],
      imgResponsive: fullBodyProtocolsImg["./costume_party_responsive.png"],
      name: "uppercaseProtocols_costumeParty",
      description: "protocols_costumePartyDescription",
      video: "protocols_costumePartyVideo",
    },
    [protocols.clinicAndHome.GENTLE_GIANT.id]: {
      img: fullBodyProtocolsImg["./gentle_giant.png"],
      imgResponsive: fullBodyProtocolsImg["./gentle_giant_responsive.png"],
      name: "uppercaseProtocols_gentleGiant",
      description: "protocols_gentleGiantDescription",
      video: "protocols_gentleGiantVideo",
    },
  };

  return protocolsData[Number(protocolId)];
};
